module.exports = __webpack_public_path__ + "img/HU10189377.3b949afb.png";